module.exports = __webpack_public_path__ + "static/media/myid_brochure_v1.0.ae5f4b42.pdf";